import { cn } from "@/lib/utils";
import { Check } from "lucide-react";

function Stepper({ steps, currentStep, className, onStepClick }) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;

        return (
          <div key={index} className="flex items-center gap-2">
            {index > 0 && (
              <div
                className={cn(
                  "h-px w-8 sm:w-12",
                  isCompleted ? "bg-coral" : "bg-border"
                )}
              />
            )}
            <button
              type="button"
              onClick={() => onStepClick?.(index)}
              disabled={!onStepClick}
              className={cn(
                "flex items-center gap-2 rounded-full transition-colors",
                onStepClick && "cursor-pointer",
                !onStepClick && "cursor-default"
              )}
            >
              <div
                className={cn(
                  "flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-medium transition-colors",
                  isCompleted && "bg-coral text-white",
                  isCurrent && "bg-coral text-white ring-2 ring-coral/30 ring-offset-2",
                  !isCompleted && !isCurrent && "bg-muted text-muted-foreground border border-border"
                )}
              >
                {isCompleted ? (
                  <Check className="h-4 w-4" />
                ) : (
                  index + 1
                )}
              </div>
              <span
                className={cn(
                  "hidden text-sm font-medium sm:inline",
                  isCurrent ? "text-foreground" : "text-muted-foreground"
                )}
              >
                {step.title || step}
              </span>
            </button>
          </div>
        );
      })}
    </div>
  );
}

export { Stepper };
